import type * as React from 'react';
import { Badge } from '@avanta/shared/components/ui/Badge';
import { type SessionStatus } from '@avanta/shared/constants/appointments';
import { cn } from '@avanta/shared/utils/cn';
import { sessionStatusBadgeVariants } from './styles';

interface SessionStatusBadgeProps extends Omit<
  React.ComponentProps<typeof Badge>,
  'asChild' | 'size'
> {
  status: SessionStatus;
  size?: React.ComponentProps<typeof Badge>['size'];
}

export const SessionStatusBadge = ({
  status,
  size = 'sm',
  className,
  children,
  ...props
}: React.PropsWithChildren<SessionStatusBadgeProps>): React.ReactElement => (
  <Badge size={size} className={cn(sessionStatusBadgeVariants({ status }), className)} {...props}>
    {children}
  </Badge>
);
